import { render, staticRenderFns } from "./EnrollDetail.vue?vue&type=template&id=42b37020&scoped=true&"
import script from "./EnrollDetail.vue?vue&type=script&lang=js&"
export * from "./EnrollDetail.vue?vue&type=script&lang=js&"
import style0 from "./EnrollDetail.vue?vue&type=style&index=0&id=42b37020&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b37020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42b37020')) {
      api.createRecord('42b37020', component.options)
    } else {
      api.reload('42b37020', component.options)
    }
    module.hot.accept("./EnrollDetail.vue?vue&type=template&id=42b37020&scoped=true&", function () {
      api.rerender('42b37020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Enroll/EnrollDetail.vue"
export default component.exports